export default "__VITE_ASSET__kNieOiwg__"